import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { getSEOData } from '../utils/seoData';
import './Narrative.css';

function Privacy() {
  return (
    <div className="np-page">
      <SEO {...getSEOData('privacy')} />

      <section className="np-hero np-hero--compact">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="np-hero-sub">
            How Codentic AI handles information submitted through this website.
          </p>
        </div>
      </section>

      <section className="np-section">
        <div className="container">
          <div className="np-prose">
            <p className="np-updated">Last updated: 18 September 2026</p>

            <h2>1. Who we are</h2>
            <p>
              This website is operated by Codentic AI (&ldquo;we&rdquo;, &ldquo;us&rdquo;). This
              policy describes what information we collect through the site, why we collect it, and
              what we do with it.
            </p>

            <h2>2. Information you give us</h2>
            <p>We collect information only when you choose to submit it:</p>
            <ul>
              <li>
                <strong>Contact form</strong> — your name, email address, optional phone number,
                the service you selected, and your message. We use this solely to respond to your
                enquiry.
              </li>
              <li>
                <strong>NanoLM document analysis</strong> — files you attach in the NanoLM
                interface are transmitted to our own self-hosted processing service so that the
                requested extraction or analysis can be performed and returned to you.
              </li>
            </ul>

            <h2>3. Information we do not collect</h2>
            <ul>
              <li>
                We do not run advertising or behavioural-tracking scripts on this site, and we do
                not sell personal information.
              </li>
              <li>
                We do not require an account to browse the public pages of this site.
              </li>
            </ul>

            <h2>4. Cookies and session state</h2>
            <p>
              The public pages of this site do not set advertising or tracking cookies, and
              browsing them does not require an account or a session cookie. We set no cookie
              that identifies you.
            </p>

            <h2>5. How we store and share information</h2>
            <ul>
              <li>
                Enquiries are delivered to our internal support mailbox and
                recorded on our own systems for follow-up.
              </li>
              <li>
                We do not sell, rent or trade your information. We share it only with service
                providers strictly necessary to operate the site and respond to you, or where we
                are required to do so by law.
              </li>
              <li>
                Our product proof-of-concepts are designed to run on-premise and self-hosted, where
                customer content does not leave the customer&rsquo;s own boundary. Where a
                deployment is self-hosted, document processing happens within that deployment.
              </li>
            </ul>

            <h2>6. Retention</h2>
            <p>
              We keep enquiries and access requests for as long as needed to handle your request
              and to maintain a reasonable business record. You can ask us to delete your
              information at any time.
            </p>

            <h2>7. Your choices</h2>
            <p>
              You may request access to, correction of, or deletion of the information you have
              submitted to us by writing to{' '}
              <a href="mailto:support@codenticai.com">support@codenticai.com</a>. We will respond
              within a reasonable period.
            </p>

            <h2>8. Security</h2>
            <p>
              We take reasonable technical and organisational measures to protect information
              submitted through this site. No method of transmission or storage is completely
              secure, and we cannot guarantee absolute security.
            </p>

            <h2>9. Children</h2>
            <p>
              This site is intended for a business audience and is not directed at children. We do
              not knowingly collect information from children.
            </p>

            <h2>10. Changes to this policy</h2>
            <p>
              We may update this policy from time to time. The revised version will be posted on
              this page with an updated date.
            </p>

            <h2>11. Contact</h2>
            <p>
              Questions about this policy can be sent to{' '}
              <a href="mailto:support@codenticai.com">support@codenticai.com</a>. See also our{' '}
              <Link to="/terms">Terms of Use</Link>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
